import Header from "./Header";
import Footer from "./Footer";

function Privacy() {
  return (
    <>
      <Header />

      <section className="my-6">
        <div className="container">
          <span className="text-uppercase text-secondary fw-semibold ls-sm">
            Privacy Policy
          </span>

          <h2 className="h1 fw-semibold ls-sm text-success lh-1">
            SLN Academy Privacy
          </h2>

          <div className="mt-n3 pt-2">
            <img
              src="/assets/images/line-shap.webp"
              width="230"
              className="mt-2"
              alt="line"
            />
          </div>

          <div className="mt-3 lh-md">
            <h4>PRIVACY POLICY WITH DISCLAIMER</h4>
            <p className="mb-0">
              <span className="text-danger">SLN Academy</span>
            </p>
            <p className="mb-0">(Operated by Swinglearn Network LLP)</p>
            <p>Last Updated: 2026</p>

            <h4>1. INTRODUCTION</h4>
            <p>
              Welcome to SLN Academy, an education-focused platform operated by
              Swinglearn Network LLP, dedicated to providing structured,
              practical, and skill-based education in the field of stock markets
              and financial markets.
            </p>

            <p>
              At SLN Academy, we deeply value the privacy, trust, and confidence
              of our users, students, visitors, and partners. This Privacy
              Policy with Disclaimer explains how we collect, use, store,
              protect, and disclose information, and also clearly defines the
              limitations of our services, especially in relation to financial
              markets.
            </p>

            <p>
              By accessing or using our website, mobile application, student
              portal, tools (including scanners), courses, or any services
              provided by SLN Academy, you agree to the terms outlined in this
              Privacy Policy and Disclaimer.
            </p>

            <p>
              If you do not agree with any part of this policy, you are advised
              not to use our platform or services.
            </p>

            <h4>2. ABOUT SLN ACADEMY</h4>
            <ul>
              <li>Brand Name: SLN Academy</li>
              <li>Legal Entity: Swinglearn Network LLP</li>
              <li>
                Nature of Business: Stock Market & Financial Market Education
              </li>
              <li>
                Regulatory Status: NSE Registered Authorized Person (AP Code:
                AP2486037784) under Choice Equity Broking Pvt. Ltd.
              </li>
              <li>Service Model: Education & Training Only (No Advisory)</li>
            </ul>

            <p>
              SLN Academy operates strictly as an educational institution, not
              as an investment adviser, portfolio manager, research analyst, or
              stock tip provider.
            </p>

            <h4>3. INFORMATION WE COLLECT</h4>
            <p>
              We may collect various types of information to ensure smooth
              functioning of our educational services.
            </p>

            <h5>3.1 Personal Information</h5>
            <p>
              Information voluntarily provided by users, including but not
              limited to:
            </p>
            <ul>
              <li>Full Name</li>
              <li>Email Address</li>
              <li>Mobile Number</li>
              <li>City, State, Country</li>
              <li>Educational background (optional)</li>
              <li>Course enrollment details</li>
            </ul>

            <h5>3.2 Account & Platform Information</h5>
            <p>When you register or log in:</p>
            <ul>
              <li>Username & encrypted password</li>
              <li>Login timestamps</li>
              <li>Course progress & learning activity</li>
            </ul>

            <h5>3.3 Payment Information</h5>
            <ul>
              <li>Transaction reference numbers</li>
              <li>Payment status</li>
              <li>Payment gateway identifiers</li>
            </ul>

            <p>
              <strong>Important:</strong>
            </p>
            <p>
              SLN Academy does not store credit/debit card details, UPI IDs, or
              net banking credentials. Payments are processed through secure
              third-party payment gateways.
            </p>

            <h5>3.4 Technical & Usage Data</h5>
            <ul>
              <li>IP address</li>
              <li>Browser type & device information</li>
              <li>Operating system</li>
              <li>Website interaction data</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>

            <h4>4. HOW WE USE YOUR INFORMATION</h4>
            <p>
              Collected information is used strictly for legitimate educational
              and operational purposes:
            </p>
            <ul>
              <li>Course enrollment & access management</li>
              <li>Student communication & academic support</li>
              <li>
                Sending class updates, announcements, and learning materials
              </li>
              <li>Improving platform performance & user experience</li>
              <li>Internal analysis and reporting</li>
              <li>Legal, regulatory, and compliance requirements</li>
            </ul>

            <p>
              We do not sell, rent, lease, or commercially exploit user data.
            </p>

            <h4>5. DATA SECURITY & PROTECTION</h4>
            <p>
              SLN Academy follows reasonable technical, administrative, and
              organizational safeguards to protect user information, including:
            </p>
            <ul>
              <li>Secure servers</li>
              <li>Encrypted communication protocols</li>
              <li>Restricted internal access</li>
              <li>Periodic system monitoring</li>
            </ul>

            <p>
              However, users must understand that no digital platform can
              guarantee 100% security, and SLN Academy shall not be held liable
              for breaches beyond its reasonable control.
            </p>

            <h4>6. COOKIES & TRACKING TECHNOLOGIES</h4>
            <p>Our website and applications may use cookies to:</p>
            <ul>
              <li>Enhance user experience</li>
              <li>Analyze traffic patterns</li>
              <li>Improve platform performance</li>
            </ul>

            <p>
              Users may disable cookies through browser settings; however, some
              features may not function optimally.
            </p>

            <h4>7. THIRD-PARTY SERVICES & LINKS</h4>
            <p>
              SLN Academy may integrate or link to third-party services,
              including but not limited to:
            </p>
            <ul>
              <li>Payment gateways</li>
              <li>Market data providers</li>
              <li>NSE or broker websites</li>
              <li>Communication tools</li>
            </ul>

            <p>
              We are not responsible for the privacy practices, data handling,
              or content of third-party platforms. Users are advised to review
              their respective privacy policies.
            </p>

            <h4>8. MARKET DATA & TOOLS (INCLUDING SCANNERS)</h4>
            <p>
              SLN Academy may display real-time or delayed market data through
              authorized sources for educational purposes only:
            </p>
            <ul>
              <li>Option chain data</li>
              <li>Market depth</li>
              <li>Open Interest (OI)</li>
              <li>Volume & price data</li>
              <li>Scanners & analytical tools</li>
            </ul>

            <ul>
              <li>Do not generate buy/sell signals</li>
              <li>Do not provide trading recommendations</li>
              <li>Are not meant for live trading decisions</li>
            </ul>

            <h4>9. DISCLAIMER – EDUCATIONAL PURPOSE ONLY</h4>

            <h5>9.1 No Investment Advice</h5>
            <ul>
              <li>Does not provide investment advice</li>
              <li>Does not offer trading tips</li>
              <li>Does not recommend buying or selling securities</li>
              <li>Does not guarantee profits or returns</li>
            </ul>

            <p>
              All content, videos, courses, tools, scanners, and data are
              provided purely for educational and informational purposes.
            </p>

            <h5>9.2 User Responsibility</h5>
            <ul>
              <li>All decisions are taken by the user</li>
              <li>Based on user's own research and risk appetite</li>
            </ul>

            <p>
              SLN Academy shall not be responsible for any losses or damages
              arising from such decisions.
            </p>

            <h5>9.3 Market Risk Warning</h5>
            <p>Stock market investments are subject to market risks.</p>
            <p>Past performance is not indicative of future results.</p>

            <p>
              Users are strongly advised to consult a SEBI-registered Investment
              Adviser before making any investment decisions.
            </p>

            <h4>10. REGULATORY & AP DISCLOSURE</h4>
            <p>
              Swinglearn Network LLP is an NSE Registered Authorized Person (AP)
              under Choice Equity Broking Pvt. Ltd.
            </p>
            <ul>
              <li>Allows facilitation of market access through a broker</li>
              <li>Does not authorize advisory services</li>
            </ul>

            <p>
              Educational services and AP activities are clearly segregated.
            </p>

            <h4>11. DATA RETENTION</h4>
            <ul>
              <li>Academic continuity</li>
              <li>Legal obligations</li>
              <li>Internal record-keeping</li>
            </ul>

            <p>Data is deleted or anonymized when no longer required.</p>

            <h4>12. USER RIGHTS</h4>
            <ul>
              <li>Access data</li>
              <li>Correct data</li>
              <li>Delete data</li>
            </ul>

            <h4>13. LIMITATION OF LIABILITY</h4>
            <ul>
              <li>No liability for financial losses</li>
              <li>No liability for trading outcomes</li>
              <li>No liability for third-party failures</li>
            </ul>

            <h4>14. POLICY UPDATES</h4>
            <p>
              SLN Academy may update this policy anytime. Continued use means
              acceptance.
            </p>

            <h4>15. GOVERNING LAW</h4>
            <p>
              Governed by laws of India. Jurisdiction: Uttar Pradesh courts.
            </p>

            <h4>16. CONTACT INFORMATION</h4>
            <p className="mb-0">SLN Academy (Swinglearn Network LLP)</p>
            <p className="mb-0">Kaushambi, Uttar Pradesh, India</p>
            <p className="mb-0">Email: slnacademyofficial@gmail.com</p>
            <p className="mb-0">Phone: 6386191243</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Privacy;
